import { useRef } from 'react';

export const useConst = <T>(initializer: () => T): T => {
  const ref = useRef<T>();
  if (ref.current === undefined) {
    ref.current = initializer();
  }
  return ref.current;
};
